import { medialUrl } from "../../../EndPoints";
import OuterImg from "../../../assets/images/sister-concern/bd-star-knit-composite/outer-img.png";
import ProductLineImg from "../../../assets/images/sister-concern/bd-star-knit-composite/product-line.png";
import MainFabricImg from "../../../assets/images/sister-concern/bd-star-knit-composite/main-fabric.png";

import SferaLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/sfera.png";
import ElCorteLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/el-corte.png";
import NavialeLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/naviale.png";
import VertbaudetLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/verbaudet.png";
import DanJohnLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/dan-john.png";
import PuntoromaLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/dan-john.png";
import SportsDirectLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/dan-john.png";
import SoulcalLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/soulcal.png";
import JackWillsLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/jack-wills.png";
import FoundryLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/foundry.png";
import FcbLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/bercelona.png";
import ManUtdLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/manutd.png";
import LiveraLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/livera.png";
import PrenatalLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/prenatal.png";
import SergentMajorLogo from "../../../assets/images/sister-concern/bd-star-knit-composite/logos/sergent-major.png";

export const mainProductContent = {
  title: "Main Products",
  outerImage: OuterImg,
  arr: [
    {
      img: ProductLineImg,
      innerTitle: "Main Fabric Qualities",
      innerText:
        "Single jersey, Heavy jersey, Polo pique, Interlock, Drop needle, Herringbone, Lacoste, Pop com, Terry Waffle, Jacquard, 2/3 Thread fleece (Brushed/Un- brushed), Loop knit, Rib, Striper peach & Emetizing, Collar & Cuff etc. with open width & tubular finish.",
    },
    {
      img: MainFabricImg,
      innerTitle: "Product Line",
      innerText:
        "Basic T-Shirt, Fashionable T-shirt, Fleece, Fleece Terry, Fleece Jacket, Basic Polo Shirt, Fashionable Polo shirt, Dress (Ladies or Kids), Basic Trouser, Fashionable Trouser, Boxer Short, Tank Top/ Ladies Fancy Items",
    },
  ],
};

export const OurCustomersImagesPoleStarKnit = [
  [
    SferaLogo,
    ElCorteLogo,
    NavialeLogo,
    VertbaudetLogo,
    DanJohnLogo,
    PuntoromaLogo,
    SportsDirectLogo,
  ],
  [
    SoulcalLogo,
    JackWillsLogo,
    FoundryLogo,
    FcbLogo,
    ManUtdLogo,
    LiveraLogo,
    PrenatalLogo,
  ],
  [
    SergentMajorLogo,
    SoulcalLogo,
    NavialeLogo,
    VertbaudetLogo,
    DanJohnLogo,
    PuntoromaLogo,
  ],
];
